import {
  Stepper,
  Form,
  Email,
  PhoneNumber,
  NameTextField,
  Button,
  CompanyCity,
  CompanySIRET,
  Select,
  Checkbox,
  TextField,
  Hidden
} from "@lmt/taskforce-react-form";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import FormLabel from "@mui/material/FormLabel";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const theme = createTheme({
  components: {
    MuiButton: {
      defaultProps: {
        size: "large",
      },
      styleOverrides: {
        root: {
          borderRadius: 28,
          backgroundColor: "#F70100",
          "&:hover": {
            backgroundColor: "#F70100",
          },
        },
      },
    },
    MuiCheckbox: {
      defaultProps: {
        size: "small",
      },
    },
    MuiFormControl: {
      defaultProps: {
        margin: "dense",
        size: "small",
      },
    },
    MuiFormHelperText: {
      defaultProps: {
        margin: "dense",
      },
    },
    MuiInputBase: {
      defaultProps: {
        margin: "dense",
      },
    },
    MuiInputLabel: {
      defaultProps: {
        margin: "dense",
      },
    },
    MuiRadio: {
      defaultProps: {
        size: "small",
      },
    },
    MuiTextField: {
      defaultProps: {
        margin: "dense",
        size: "small",
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Stepper
        steps={[
          <Form onSubmit={(data) => console.log(data)}>
            <Box sx={{ flexGrow: 1 }}>
              <Grid
                container
                spacing={{ xs: 1, md: 1 }}
                columns={{ xs: 4, sm: 12, md: 12 }}
              >
                <Grid item xs={6}>
                  <Box mt={-0.5}>
                    <NameTextField
                      label="Nom"
                      name="last_name"
                      required="Merci de saisir votre nom"
                      validatorMessage="Votre nom est incorrect"
                    />
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box mt={-0.5}>
                    <NameTextField
                      label="Prénom"
                      name="first_name"
                      required="Merci de saisir votre prénom"
                      validatorMessage="Votre prénom est incorrect"
                    />
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box mt={-0.5}>
                    <PhoneNumber
                      label="Téléphone"
                      name="phone_number_office"
                      required="Merci de saisir votre téléphone"
                      validatorMessage="Votre téléphone est incorrect"
                    />
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box mt={-0.5}>
                    <Email
                        label="Email"
                        name="email"
                        required="Merci de saisir votre email"
                        validatorMessage="Votre email est incorrect"
                    />
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box mt={-0.5}>
                    <Box>
                      <CompanyCity
                          propsCompany={{
                            label: "Société",
                            name: "autocomplete_company",
                            companyName: "company_name",
                            sirenName: "siren",
                            required: "Société obligatoire",
                            companyAddress: "address",
                            companyZipcode: "company_zipcode",
                          }}
                          propsCity={{
                            label: "Ville",
                            name: "autocompletion_city",
                            cityName: "city",
                            postcodeName: "zipcode",
                            cityInseeCodeName: "insee_code_city",
                            required: "Ville obligatoire",
                          }}
                      />
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={4}>
                  <Box mt={-0.5}>
                    <CompanySIRET
                      label="Établissement"
                      name="company_siret"
                      addressName="address"
                      postcodeName="zipcode"
                      codeNafName="company_naf_code"
                      cityInseeCodeName="insee_code"
                      required="Merci de saisir votre établissement"
                      dependOfCity="insee_code_city"
                    />
                  </Box>
                </Grid>
                <Grid item xs={4}>
                  <Box mt={-0.5}>
                    <Select
                      label="Nombre de véhicules dans le parc"
                      name="project_description"
                      required="Merci de choisir un nombre de véhicules"
                      items={[
                        {
                          value: "moins de 30 vehicules",
                          label: "moins de 30",
                        },
                        {
                          value: "plus de 30 vehicules",
                          label: "plus de 30",
                        },
                      ]}
                    />
                  </Box>
                </Grid>
                <Grid item xs={4}>
                  <Box mt={-0.5}>
                    <TextField
                      name="misc"
                      label="Consommation mensuelle de carburant (en l/mois)"
                      required={false}
                    />
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box mt={-2}>
                    <Checkbox
                      label="J'accepte que TotalEnergies utilise ces coordonnées pour me contacter en vue de définir mon offre personnalisée de carte carburant"
                      required
                      name="reference_optin"
                    />
                  </Box>
                </Grid>
                <Grid item xs={4}>
                  <Box mt={0}>
                    <FormLabel>* Champs obligatoires</FormLabel>
                  </Box>
                </Grid>
                <Hidden name="origin"/>
                <Grid item xs={2}>
                  <Box mt={0} mr={8}>
                    <Button />
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Form>,
        ]}
      />
    </ThemeProvider>
  );
}

export default App;
